import { render, staticRenderFns } from "./uploadFiles2.vue?vue&type=template&id=4e2d1053&scoped=true&"
import script from "./uploadFiles2.vue?vue&type=script&lang=js&"
export * from "./uploadFiles2.vue?vue&type=script&lang=js&"
import style0 from "./uploadFiles2.vue?vue&type=style&index=0&id=4e2d1053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d1053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
